<template>
  <transition name="fade">
    <b-container v-if="transactions">
      <b-row>
        <b-col class="p-0 mb-2">
          <h4 class="font-weight-bold">Charge History</h4>
          <p
            class="grey-dark transactions-no-content"
            v-if="transactions.length === 0"
          >
            <small> No transactions found </small>
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-for="(row, index) in transactions"
          :key="index"
          class="transaction-detail overflow-hidden text-left gradient-border py-3 m-0"
          cols="12"
          lg="6"
        >
          <b-row align-v="center">
            <b-col cols="2" lg="1" class="p-0 pl-3">
              <b-link
                :to="
                  '/influencer/' +
                  row.influencer.influencer_uid +
                  `/` +
                  row.influencer.username
                "
              >
                <div
                  class="rounded-circle cursor"
                  v-if="row.influencer"
                  :style="
                    `background:url(` +
                    row.influencer.profile_photo_url +
                    `) center/cover;
                    padding: 50%`
                  "
                />
              </b-link>
            </b-col>

            <b-col cols="7" class="pr-0">
              <p class="p-0 m-0" style="line-height: 16px">
                <small>{{ row.description }}</small>
              </p>
              <p class="p-0 m-0">
                <small class="grey-light">
                  {{ convertDate(row.paid_at) }}
                </small>
              </p>
            </b-col>

            <b-col cols="3" align-self="baseline">
              <b-link
                class="grey-light"
                :href="row.receipt_url"
                target="_blank"
                style="line-height: 10px"
              >
                <small>
                  <small>Receipt</small>
                </small>
              </b-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </transition>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TransactionsPage',

  computed: {
    ...mapState({
      transactions: (state) => state.auth.transactions,
    }),
  },

  methods: {
    ...mapActions({
      getUserTransactions: 'auth/getUserTransactions',
    }),

    convertDate(dateMillis) {
      return moment(dateMillis).format('MMM DD, YYYY')
    },

    openLink(externalLink) {
      window.location = externalLink
    },
  },

  async created() {
    await this.getUserTransactions()
  },
}
</script>

<style scoped></style>
